import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../constants";

/* ---------- VIP badge ---------- */

const useVip = makeStyles({
  vip: {
    background: T.primary,
    color: T.primaryFg,
    borderRadius: 4,
    padding: "1px 6px",
    fontSize: 10,
    fontWeight: 700,
    textTransform: "uppercase",
  },
});

export default function VipBadge() {
  const c = useVip();
  return <span className={c.vip}>VIP</span>;
}
